/**
 * Push Notifications — Capacitor scaffold for Lumivera mobile.
 *
 * NOT auto-wired yet. To activate:
 *   1. Configure FCM (Android) + APNs (iOS) — see /app/memory/MOBILE_LAUNCH_CHECKLIST.md
 *   2. Add a POST /api/devices/register endpoint on the backend
 *   3. Call `registerPushNotifications()` from a post-login effect
 *   4. Send pushes from the backend via FCM HTTP v1.
 */
import { Capacitor } from "@capacitor/core";

export async function registerPushNotifications(onToken) {
  if (!Capacitor.isNativePlatform()) return null;
  try {
    const { PushNotifications } = await import("@capacitor/push-notifications");

    let perm = await PushNotifications.checkPermissions();
    if (perm.receive === "prompt" || perm.receive === "prompt-with-rationale") {
      perm = await PushNotifications.requestPermissions();
    }
    if (perm.receive !== "granted") return null;

    await PushNotifications.register();

    PushNotifications.addListener("registration", (token) => {
      if (typeof onToken === "function") onToken(token.value);
    });
    PushNotifications.addListener("registrationError", (err) => {
       
      console.warn("Push registration error", err);
    });
    PushNotifications.addListener("pushNotificationReceived", (notification) => {
      // Show in-app toast or update state. Left for app-level integration.
       
      console.log("Push received", notification);
    });
    PushNotifications.addListener("pushNotificationActionPerformed", (action) => {
      // Route to a specific page when the user taps a notification.
       
      console.log("Push action", action);
    });

    return true;
  } catch (e) {
     
    console.warn("Push plugin unavailable", e);
    return null;
  }
}
